export default "__VITE_ASSET__f627661a__"